// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_17UFSyfxDQoJtDmeBSI5Q9","icon":"_1AMXa_mKljBGLzEuWSpBq5","active":"_3ElIzxK0gL_iULEEdkqHDh"};